import { connect } from 'react-redux';

import { FORM_ERROR } from 'final-form';
import { AnyAction, Dispatch } from 'redux';

import { FETCH_ERROR, FETCH_SUCCESS } from '@nord/tool.redux-api/es/actionTypes';

import fetchErrorFromResponse from '../../../tools/fetchErrorFromResponse';
import History from '../../../tools/history';
import { ILoginFormValues } from '../../components/organisms/LoginForm';
import LoginForm, { IProps as ILoginFormOwnProps } from '../../components/templates/Login';
import { toggleRememberMe } from '../../store/actions';
import { getRememberMe } from '../../store/selectors';

interface IState {
  rememberMe?: boolean;
}

interface IDispatch {
  onSubmit: (values: ILoginFormValues) => Promise<boolean | void | Record<string, any>>;
}

const mapStateToProps = (state: any) => ({
  rememberMe: getRememberMe(state),
});

export interface IContainerProps extends Omit<ILoginFormOwnProps, 'onSubmit'> {
  loginAction: (values: ILoginFormValues) => AnyAction;
}

interface ILoginSubmitParams extends ILoginFormValues {
  organization?: string;
}
const mapDispatchToProps = (
  dispatch: Dispatch,
  { loginAction, organization }: IContainerProps
) => ({
  onSubmit: async ({ email, password, remember_me: rememberMe }: ILoginFormValues) => {
    const loginParams: ILoginSubmitParams = { email, password };
    if (organization) {
      loginParams.organization = organization;
    }
    const { type, payload: { response = null, errorResponse = null } = {} } = await dispatch(
      loginAction(loginParams)
    );

    switch (type) {
      case FETCH_SUCCESS:
        await dispatch(toggleRememberMe(rememberMe));
        return History.push('/');
      case FETCH_ERROR:
        return {
          [FORM_ERROR]: fetchErrorFromResponse(errorResponse ?? response),
        };
      default:
        break;
    }

    return false;
  },
});

export default connect<IState, IDispatch, IContainerProps>(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);
